import { render, staticRenderFns } from "./PopularOffers.vue?vue&type=template&id=6f956c3a"
import script from "./PopularOffers.vue?vue&type=script&lang=js"
export * from "./PopularOffers.vue?vue&type=script&lang=js"
import style0 from "./PopularOffers.vue?vue&type=style&index=0&id=6f956c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4_6c7cc6d5fe7e019addcd681de453173a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports